import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "explanation"]
  static values = { publicKey: String, createUrl: String, destroyUrl: String, texts: Object }

  async connect() {
    if (!this.supported()) {
      this.explanationTarget.textContent = this.iosWithoutHomeScreen()
        ? this.textsValue.home_screen
        : this.textsValue.unsupported
      return
    }

    if (Notification.permission === "denied") {
      this.showPermissionDenied()
      return
    }

    this.registration = await navigator.serviceWorker.register("/service-worker")
    this.subscription = await this.registration.pushManager.getSubscription()
    this.renderState()
  }

  async toggle() {
    this.buttonTarget.disabled = true
    try {
      if (this.subscription) {
        await this.removeSubscription()
      } else {
        await this.addSubscription()
      }
    } catch (_error) {
      this.explanationTarget.textContent = this.textsValue.failed
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  supported() {
    return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window && !this.iosWithoutHomeScreen()
  }

  iosWithoutHomeScreen() {
    const ios = /iPhone|iPad|iPod/.test(navigator.userAgent)
    const standalone = window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches
    return ios && !standalone
  }

  async addSubscription() {
    const permission = await Notification.requestPermission()
    if (permission !== "granted") {
      this.showPermissionDenied()
      return
    }

    this.subscription = await this.registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: this.applicationServerKey()
    })
    const response = await fetch(this.createUrlValue, this.requestOptions("POST", { subscription: this.subscription.toJSON() }))
    if (!response.ok) {
      await this.subscription.unsubscribe()
      this.subscription = null
      throw new Error("Het toestel kon niet worden aangemeld")
    }
    this.renderState()
  }

  async removeSubscription() {
    const endpoint = this.subscription.endpoint
    const response = await fetch(this.destroyUrlValue, this.requestOptions("DELETE", { endpoint }))
    if (!response.ok) throw new Error("Het toestel kon niet worden afgemeld")

    await this.subscription.unsubscribe()
    this.subscription = null
    this.renderState()
  }

  renderState() {
    this.buttonTarget.classList.remove("hidden")
    this.buttonTarget.textContent = this.subscription ? this.textsValue.turn_off : this.textsValue.turn_on
    this.explanationTarget.textContent = this.subscription
      ? this.textsValue.on
      : this.textsValue.off
  }

  showPermissionDenied() {
    this.buttonTarget.classList.add("hidden")
    this.explanationTarget.textContent = this.textsValue.denied
  }

  applicationServerKey() {
    const padding = "=".repeat((4 - this.publicKeyValue.length % 4) % 4)
    const base64 = (this.publicKeyValue + padding).replace(/-/g, "+").replace(/_/g, "/")
    return Uint8Array.from(window.atob(base64), character => character.charCodeAt(0))
  }

  requestOptions(method, body) {
    return {
      method,
      headers: { "Content-Type": "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content },
      body: JSON.stringify(body)
    }
  }
}
